const StatusEnum = {
  INATIVO: '0',
  ATIVO: '1',
  AGUARDANDO: '2',
}

export default StatusEnum
